import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
// 导入进度条动画
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Message } from 'element-ui';
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    redirect: '/Home', // 重定向到/home
  },
  {
    path: '/Home',
    name: 'Home',
    meta: { title: '主页', roles: [] },
    component: () => import('@/views/index.vue'),
    redirect: '/Home/pages',
    children: [
      {
        path: 'pages',
        name: 'pages',
        component: () => import('@/views/home/home.vue'),
        meta: { title: '首页' },
      },
      {
        path: 'industrialEcology',
        name: 'industrialEcology',
        component: () => import('@/views/IndustrialEcology/index.vue'),
        meta: { title: '企业名录' },
      },
      {
        path: 'oneClickRecycle',
        name: 'oneClickRecycle',
        component: () => import('@/views/oneClickRecycle/index.vue'),
        meta: { title: '天府码上收' },
      },
      {
        path: 'policyInformation',
        name: 'policyInformation',
        component: () => import('@/views/policyInformation/index.vue'),
        meta: { title: '政策资讯' },
      },
      {
        path: 'priceIndex',
        name: 'priceIndex',
        component: () => import('@/views/PriceIndex/index.vue'),
        meta: { title: '价格指数' },
      },
      {
        path: 'supplyDemand',
        name: 'supplyDemand',
        component: () => import('@/views/SupplyAndDemandInfo/index.vue'),
        meta: { title: '供需信息' },
        redirect: '/Home/supplyDemand/supplyHall',
        children: [
          {
            path: 'supplyHall',
            name: 'supplyHall',
            component: () =>
              import('@/views/SupplyAndDemandInfo/component/supplyHall.vue'),
            meta: { title: '供应大厅' },
          },
          {
            path: 'purchaseHall',
            name: 'purchaseHall',
            component: () =>
              import('@/views/SupplyAndDemandInfo/component/purchaseHall.vue'),
            meta: { title: '求购大厅' },
          },
        ],
      },
      {
        path: 'aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/aboutUs/index.vue'),
        meta: { title: '关于我们' },
        redirect: '/Home/aboutUs/companyProfile',
        children: [
          {
            path: 'companyProfile',
            name: 'companyProfile',
            component: () => import('@/views/aboutUs/companyProfile.vue'),
            meta: { title: '公司简介' },
          },
          {
            path: 'associationProfile',
            name: 'associationProfile',
            component: () => import('@/views/aboutUs/associationProfile.vue'),
            meta: { title: '协会简介' },
          },
          {
            path: 'joinAssociation',
            name: 'joinAssociation',
            component: () => import('@/views/aboutUs/joinAssociation.vue'),
            meta: { title: '加入协会' },
          },
        ],
      },
      {
        path: 'government',
        name: 'government',
        component: () => import('@/views/government/index.vue'),
        redirect: '/homePage',
        meta: { title: '政务服务' },
        children: [
          {
            path: 'homePage',
            name: 'homePage',
            component: () =>
              import('@/views/government/component/homePages.vue'),
            meta: { title: '政务主页' },
          },
          {
            path: 'SubsidyApplication',
            name: 'SubsidyApplication',
            component: () =>
              import('@/views/government/component/SubsidyDetail.vue'),
            meta: { title: '补贴申领' },
          },
          {
            path: 'ScrappedCar',
            name: 'ScrappedCar',
            component: () =>
              import('@/views/government/component/ScrapCarDetail.vue'),
            meta: { title: '报废汽车' },
          },
          {
            path: 'TradeInForNew',
            name: 'TradeInForNew',
            component: () =>
              import('@/views/government/component/TradeInForNew.vue'),
            meta: { title: '以旧换新' },
          },
          {
            path: 'governmentServices',
            name: 'governmentServices',
            component: () =>
              import('@/views/government/component/governmentServices.vue'),
            meta: { title: '再生资源备案' },
          },
          {
            path: 'discardedElectronics',
            name: 'discardedElectronics',
            component: () =>
              import('@/views/government/component/discardedElectronics.vue'),
            meta: { title: '废弃电子产品' },
          },
          {
            path: 'policyInquiry',
            name: 'policyInquiry',
            component: () =>
              import('@/views/government/component/policyInquiry.vue'),
            meta: { title: '政策查询' },
          },
        ],
      },
      {
        path: 'addedServices',
        name: 'addedServices',
        component: () => import('@/views/addedServices/index.vue'),
        meta: { title: '增值服务' },
        redirect: '/Home/addedServices/serviceList',
        children: [
          {
            path: 'serviceList',
            name: 'serviceList',
            component: () => import('@/views/addedServices/serviceList.vue'),
          },
          {
            path: 'detail',
            name: 'serviceDetail',
            component: () => import('@/views/addedServices/serviceDetail.vue'),
            meta: {
              title: '增值服务详情',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/mapscp',
    name: 'mapscp',
    component: () => import('@/views/ChinaMapData/index.vue'),
    meta: { title: '全国地理数据' },
  },
  {
    path: '/recyclingOutlets',
    name: 'recyclingOutlets',
    component: () => import('@/views/IndustryMap/index.vue'),
    meta: { title: '产业地图', roles: [] },
  },
  {
    path: '/wholeProcess',
    name: 'wholeProcess',
    component: () => import('@/views/wholeProcess/index.vue'),
    meta: {
      title: '全流程溯源',
      roles: [],
      requireUserType: 3, // 新增：指定需要的用户类型
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/search/index.vue'),
    meta: {
      title: '快捷搜索',
      roles: [],
    },
  },
  {
    path: '/secondaryHomepage',
    name: 'secondaryHomepage',
    component: () => import('@/views/secondaryHomepage/index.vue'),
    meta: { title: '全流程溯源', roles: [] },
    children: [
      {
        path: 'carbonFootprint',
        name: 'carbonFootprint',
        component: () => import('@/views/carbonFootprint/index.vue'),
        meta: { title: '碳足迹管理', roles: [] },
      },
      {
        path: 'traceabilitySupervision',
        name: 'traceabilitySupervision',
        component: () => import('@/views/traceabilitySupervision/index.vue'),
        meta: { title: '溯源监管', roles: [] },
      },
      {
        path: 'supplyChain',
        name: 'supplyChain',
        component: () => import('@/views/supplyChain/index.vue'),
        meta: { title: '供应链金融', roles: [] },
      },
      {
        path: 'industrialChain',
        name: 'industrialChain',
        component: () => import('@/views/industrialChain/index.vue'),
        meta: { title: '产业链大数据', roles: [] },
      },
      {
        path: 'marketRiskControl',
        name: 'marketRiskControl',
        component: () => import('@/views/marketRiskControl/index.vue'),
        meta: { title: '市场风控', roles: [] },
      },
      {
        path: 'supplyDemand',
        name: 'supplyDemand',
        component: () => import('@/views/supplyDemand/index.vue'),
        meta: { title: '供需信息', roles: [] },
      },
      {
        path: 'transactionMatching',
        name: 'transactionMatching',
        component: () => import('@/views/transactionMatching/index.vue'),
        meta: { title: '交易撮合', roles: [] },
      },
    ],
  },
  {
    path: '/largeScreen',
    name: 'largeScreen',
    component: () => import('@/views/largeScreen/index.vue'),
    meta: { title: '大屏展示中心', roles: [] },
  },
  {
    path: '/managementPage',
    name: 'managementPage',
    component: () => import('@/views/managementPage/index.vue'),
    meta: { title: '收运管理', roles: [] },
  },
  {
    path: '/empty',
    name: 'empty',
    component: () => import('@/views/empty/index.vue'),
    meta: { title: '开发中', roles: [] },
  },
  {
    path: '/SignIn',
    name: 'SignIn',
    component: () => import('@/views/Regulatory/Login/SignIn.vue'),
    meta: { title: '监管登录', roles: [] },
  },
  {
    path: '/supervisionHomepage',
    name: 'supervisionHomepage',
    component: () => import('@/views/Regulatory/HOME/index.vue'),
    redirect: '/supervisionHomepage/Punishment',
    meta: { title: '安全监管', roles: [] },
    children: [
      {
        path: 'Punishment',
        name: 'Punishment',
        component: () => import('@/views/Regulatory/HOME/pages/index.vue'),
        meta: { title: '处罚事件' },
      },
      {
        path: 'PunishmentDetails',
        name: 'PunishmentDetails',
        component: () =>
          import('@/views/Regulatory/HOME/PunishmentDetails/index.vue'),
        meta: { title: '处罚事件详情' },
      },
    ],
  },
  {
    path: '/watePrice',
    name: 'watePricePage',
    component: () => import('@/views/reportPage/index.vue'),
    children: [
      {
        path: 'priceReport',
        name: 'reportPage',
        component: () => import('@/views/reportPage/priceReport.vue'),
        meta: { title: '价格上报' },
      },
    ],
  },
  {
    path: '/qualificationApplication',
    name: 'qualificationApplication',
    component: () => import('@/views/apply/qualificationApplication.vue'),
    meta: { title: '申报资格' },
  },
  {
    path: '/subsidyApplication',
    name: 'subsidyApplication',
    component: () => import('@/views/apply/subsidyApplication.vue'),
    meta: { title: '补贴申报' },
  },
  {
    path: '/performance',
    name: 'performance',
    component: () => import('@/views/apply/performance.vue'),
    meta: { title: '绩效上报' },
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('@/views/apply/apply.vue'),
    meta: { title: '申报详情' },
  },
];

const router = new VueRouter({
  routes,
  mode: 'hash',
});
const protectedRoutes = [
  // 'industrialEcology',
  'priceIndex',
  'government',
  'recyclingOutlets',
  'wholeProcess',
  // 'Punishment',
  // 'PunishmentDetails',
];
router.beforeEach((to, from, next) => {
  // 路由访问之前，获取本地用户会员信息是否存在，且是否在当前时间过期
  let userInfo = localStorage.getItem('ordinaryUser')
    ? JSON.parse(localStorage.getItem('ordinaryUser'))
    : null;
  if (userInfo) {
    if (
      userInfo.userDetail.memberStartTime &&
      userInfo.userDetail.memberEndTime
    ) {
      let result =
        new Date(userInfo.userDetail.memberStartTime).getTime() <
          new Date().getTime() &&
        new Date(userInfo.userDetail.memberEndTime).getTime() >
          new Date().getTime();
      if (!result) {
        userInfo.userDetail.memberStartTime = null;
        userInfo.userDetail.memberEndTime = null;
        userInfo.userDetail.memberStatus = 0;
        localStorage.setItem('ordinaryUser', JSON.stringify(userInfo));
        Message.warning('温馨提示：您的会员已到期！');
      }
    }
  }
  // 检查目标路由是否在受保护的路由列表中
  const isProtectedRoute = protectedRoutes.includes(to.name);
  // 获取 Vuex 中的用户信息
  const ordinaryUser = store.state.ordinaryUser; // 普通用户信息存储在 Vuex 的 ordinaryUser 状态中

  // 对wholeProcess路由进行特殊权限检查
  if (to.name === 'wholeProcess') {
    if (!ordinaryUser || Object.keys(ordinaryUser).length === 0) {
      // 用户未登录
      Message.closeAll();
      Message({
        type: 'error',
        message: '用户未登录，无权限查看此功能',
        center: true,
        showClose: true,
        offset: 80,
      });
      return;
    } else if (
      ordinaryUser.userDetail &&
      ordinaryUser.userDetail.userType == 1
    ) {
      // 用户类型不符合要求
      Message.closeAll();
      Message({
        type: 'error',
        message: '您的用户类型没有权限访问此功能',
        center: true,
        showClose: true,
        offset: 80,
      });
      return;
    }
    // 权限检查通过
    store.commit('updateRouterClickStatus', to.path);
    next();
    return;
  }

  if (isProtectedRoute) {
    if (ordinaryUser && Object.keys(ordinaryUser).length > 0) {
      // 如果是受保护路由且用户已登录，允许访问
      store.commit('updateRouterClickStatus', to.path);
      next();
    } else {
      // 如果是受保护路由但用户未登录，跳转到登录页
      console.log('受保护路由');
      Message.closeAll();
      Message({
        type: 'error',
        message: '用户未登录，无权限查看此功能',
        center: true,
        showClose: true,
        offset: 80,
      });
    }
  } else {
    // 非受保护路由，直接放行
    console.log('非受保护路由，直接放行');
    // 提示的进度条
    NProgress.inc(0.2);
    NProgress.configure({ easing: 'ease', speed: 700, showSpinner: false });
    store.commit('updateRouterClickStatus', to.path);
    next();
  }
});

router.afterEach(() => {
  NProgress.done(); //结束进度条
});

export default router;
